import Alpine from 'alpinejs'

Alpine.data('timezoneDate', (timestamp, format) => ({
    
    display: '',
    timezone: Alpine.store('timezone').value,
    date: new Date(timestamp * 1000),
    
    init() {
        Alpine.effect(() => {
            this.timezone = Alpine.store('timezone').value
            this.update()
        })
        this.update()
    },
    
    update() {
        const render = {
            timeZone: this.timezone
        }
        
        if(format === 'date') {
            
            render.day = '2-digit'
            render.month = '2-digit'
            render.year = 'numeric'
            
        } else if(format === 'date-month-day') {

            render.day = '2-digit'
            render.month = '2-digit'
            
        } else if(format === 'hour') {
            
            render.hour = '2-digit'
            render.minute = '2-digit'
        }
        
        this.display = new Intl.DateTimeFormat('de-DE', render).format(this.date)
    }
}))